import { resolveImagePath } from '@/utils/imageMap';

export function RCA8310ProductShowcase() {
  return (
    <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-rcallen-primary-blue uppercase font-arial mb-2">
          NEW! RCA8310 SERIES
        </h2>
        <h3 className="text-xl font-bold text-rcallen-primary-blue uppercase font-arial">
          TURN COORDINATOR/TURN & BANK
        </h3>
      </div>

      {/* Main Content Layout */}
      <div className="flex flex-col lg:flex-row gap-8">
        
        {/* Product Image */}
        <div className="lg:w-1/2">
          <div className="bg-gray-50 rounded-lg p-6 text-center">
            <img
              src={resolveImagePath('/images/RCA8310-3 Both Screens.jpg')}
              alt="RCA8310 Both Screens"
              className="w-full max-w-md mx-auto rounded-lg shadow-md"
            />
            <div className="mt-4 grid grid-cols-2 gap-4 text-sm font-arial text-rcallen-black">
              <div className="text-center">
                <div className="font-bold">TURN & BANK</div>
              </div>
              <div className="text-center">
                <div className="font-bold">TURN COORDINATOR</div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Description and Features */}
        <div className="lg:w-1/2">
          
          {/* Product Description */}
          <div className="mb-6">
            <p className="text-rcallen-black font-arial leading-relaxed">
              The <span className="font-style-italic">NEW</span> <span className="font-bold">RCA8310</span> is 
              two instruments in one. It can be used as either a Turn Coordinator or a Turn and Bank as set by the user. 
              It comes with an optional Internal Battery Backup and is fully FAA Certified.
            </p>
            <p className="text-rcallen-black font-arial font-bold mt-2">
              Available in 3-inch and 2-inch sizes.
            </p>
          </div>

          {/* Features List */}
          <div className="space-y-4">
            <div>
              <h4 className="text-rcallen-primary-blue font-bold font-arial mb-3">KEY FEATURES:</h4>
              <ul className="space-y-2 text-sm font-arial text-rcallen-black">
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>CUSTOMIZABLE DISPLAY</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>MULTI-VOLT OPERATION</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>INTERNAL BATTERY BACKUP</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>TOTALLY SELF-CONTAINED</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>EASY INSTALLATION</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>FULLY FAA CERTIFIED</span>
                </li>
                <li className="flex items-start">
                  <span className="text-rcallen-primary-blue font-bold mr-2">-</span>
                  <span>TWO YEAR LIMITED WARRANTY</span>
                </li>
              </ul>
            </div>
          </div>

          {/* More Information Link */}
          <div className="mt-6 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center justify-center">
              <a 
                href="/downloads" 
                className="inline-flex items-center gap-3 text-rcallen-primary-blue hover:text-blue-700 transition-colors"
              >
                <div className="w-8 h-8 bg-rcallen-primary-blue text-white rounded-full flex items-center justify-center text-sm">
                  i
                </div>
                <div className="text-center">
                  <div className="text-xs font-arial">CLICK HERE FOR</div>
                  <div className="text-xs font-arial font-bold">MORE INFORMATION</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Certification Logo */}
      <div className="mt-8 text-center">
        <div className="inline-block bg-gray-100 px-4 py-2 rounded-lg">
          <span className="text-sm font-arial text-rcallen-black">✓ FAA CERTIFIED</span>
        </div>
      </div>
    </div>
  );
}